import React, { FC } from "react";

import FlexibleDateBestPriceInner from "./FlexibleDateBestPriceInner";
import { useGetFlexDatesData } from "./useGetFlexDatesData";
import Frame from "../Frame";

const FlexibleDateBestPriceDesktop: FC = () => {
  const data = useGetFlexDatesData();
  if (!data) {
    return null;
  }

  const { dates, currentBestPrice, cheaperCount, isOneWay } = data;

  return (
    <Frame mb={4}>
      <FlexibleDateBestPriceInner
        carouselSize="medium"
        dates={dates}
        currentBestPrice={currentBestPrice}
        cheaperCount={cheaperCount}
        isOneWay={isOneWay}
      />
    </Frame>
  );
};

export default FlexibleDateBestPriceDesktop;
